import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (password !== confirm) { setError('Passwords don\'t match'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="page">
        <div className="page-header"><h1 className="page-title">Reset Password</h1></div>
        <div className="container">
          <div className="card" style={{ textAlign: 'center' }}>
            <p style={{ color: '#B8564A', margin: '0 0 16px' }}>Invalid reset link. Please request a new one.</p>
            <Link to="/forgot-password" className="btn btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
              Request New Link
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">New Password</h1>
      </div>
      <div className="container">
        {done ? (
          <div className="card" style={{ textAlign: 'center' }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#5A8A60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto 16px', display: 'block' }}>
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            <h3 style={{ margin: '0 0 8px', fontFamily: "'Plus Jakarta Sans', sans-serif", color: '#4A2E1F' }}>Password reset!</h3>
            <p style={{ color: '#7A5A44', fontSize: '14px', margin: '0 0 16px' }}>You can now log in with your new password.</p>
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
              Go to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="card">
              <input
                type="password"
                className="input"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoFocus
                style={{ marginBottom: '12px' }}
              />
              <input
                type="password"
                className="input"
                placeholder="Confirm new password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                style={{ marginBottom: '16px' }}
              />
              {error && <p style={{ color: '#B8564A', fontSize: '13px', margin: '0 0 12px' }}>{error}</p>}
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !password || !confirm}
                style={{ width: '100%' }}
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
